import { Text } from '@shared/components/text';
import { RateMetadata } from '@shared/types/quote';
import {
  getDrayratesAccessorialSummary,
  getDrayratesResolvedTerminalDisplay,
  getDrayratesWidgetStrategies,
  parseDrayratesRateResponse,
} from '@shared/utils/rates/drayrates';

export const DrayratesRateMoreInfo = ({
  metadata,
}: {
  metadata?: RateMetadata;
}) => {
  const response = parseDrayratesRateResponse(metadata);
  const accessorialSummary =
    response?.selectedRateKey === 'market'
      ? getDrayratesAccessorialSummary(response)
      : null;

  if (!accessorialSummary) {
    return null;
  }

  return (
    <div className="mt-1 flex flex-col gap-1">
      {accessorialSummary && (
        <Text type="custom" className="text-[10px] text-gray-500">
          {accessorialSummary}
        </Text>
      )}
    </div>
  );
};

export const DrayratesWidgetInfo = ({
  metadata,
}: {
  metadata?: RateMetadata;
}) => {
  const response = parseDrayratesRateResponse(metadata);
  const strategies = getDrayratesWidgetStrategies(response);
  const resolvedTerminal = getDrayratesResolvedTerminalDisplay(response);
  const buyStrategy = strategies.find(
    (strategy) => strategy.label === 'Buy strategy'
  );
  const sellStrategy = strategies.find(
    (strategy) => strategy.label === 'Sell strategy'
  );

  if (!resolvedTerminal && !strategies.length) {
    return null;
  }

  return (
    <div className="px-4 py-3">
      <div className="flex flex-col gap-1">
        {resolvedTerminal && (
          <Text type="custom" className="text-[10px] text-gray-500">
            {`Terminal: ${resolvedTerminal}`}
          </Text>
        )}
        {buyStrategy && (
          <Text type="custom" className="text-[10px] text-gray-500">
            {`${buyStrategy.label}: ${buyStrategy.value}`}
          </Text>
        )}
        {sellStrategy && (
          <Text type="custom" className="text-[10px] text-gray-500">
            {`${sellStrategy.label}: ${sellStrategy.value}`}
          </Text>
        )}
      </div>
    </div>
  );
};
